import request from '@/utils/request';
// 获取群组列表
export function groupCsList(params: any) {
  return request({
    url: 'GroupCs/groupCsList',
    method: 'get',
    params
  });
}
// 添加群组
export function batchAddCheckGroup(data: any) {
  return request({
    url: 'GroupCs/batchAddCheckGroup',
    method: 'POST',
    data
  });
}
// 添加群组
export function addGroupCs(data: any) {
  return request({
    url: 'GroupCs/groupCs',
    method: 'POST',
    data
  });
}
// 编辑群组
export function editGroupCs(data: any) {
  return request({
    url: 'GroupCs/groupCs',
    method: 'PUT',
    data
  });
}
// 删除群组
export function delGroupCs(data: any) {
  return request({
    url: 'GroupCs/groupCs',
    method: 'DELETE',
    data
  });
}
// 推单群组

// 获取群组列表
export function groupPushList(params: any) {
  return request({
    url: 'GroupPush/groupPushList',
    method: 'get',
    params
  });
}
// 添加群组
export function addGroupPush(data: any) {
  return request({
    url: 'GroupPush/groupPush',
    method: 'POST',
    data
  });
}
// 编辑群组
export function editGroupPush(data: any) {
  return request({
    url: 'GroupPush/groupPush',
    method: 'PUT',
    data
  });
}
// 删除群组
export function delGroupPush(data: any) {
  return request({
    url: 'GroupPush/groupPush',
    method: 'DELETE',
    data
  });
}
// 推单至排班群组
export function groupPushScheduling(data: any) {
  return request({
    url: 'GroupPush/groupPushScheduling',
    method: 'POST',
    data
  });
}

// 添加部门查看群组
export function addGroupView(data: any) {
  return request({
    url: 'GroupCs/groupView',
    method: 'POST',
    data
  });
}
// 编辑部门查看群组
export function editGroupView(data: any) {
  return request({
    url: 'GroupCs/groupView',
    method: 'PUT',
    data
  });
}
// 删除部门查看群组
export function delGroupView(data: any) {
  return request({
    url: 'GroupCs/groupView',
    method: 'DELETE',
    data
  });
}

// 获取部门查看群组列表
export function groupViewList(params: any) {
  return request({
    url: 'GroupCs/groupViewList',
    method: 'get',
    params
  });
}
